import React from 'react';
import { SectionCard, TextField, TextAreaField, ImageField } from '../../../components/admin/EditorFields';

export default function SettingsEditor({ data, setData }) {
  const update = (path, value) => {
    setData((d) => {
      const next = { ...d };
      const keys = path.split('.');
      let cur = next;
      for (let i = 0; i < keys.length - 1; i++) {
        cur[keys[i]] = { ...(cur[keys[i]] || {}) };
        cur = cur[keys[i]];
      }
      cur[keys[keys.length - 1]] = value;
      return next;
    });
  };

  return (
    <div className="space-y-5">
      <SectionCard title="Identité du site">
        <TextField label="Nom du site" value={data.siteName} onChange={(v) => update('siteName', v)} />
        <TextField label="Tagline (sous-titre)" value={data.tagline} onChange={(v) => update('tagline', v)} />
        <ImageField label="Logo" value={data.logoUrl} onChange={(v) => update('logoUrl', v)} hint="Format carré ou rond recommandé (PNG/AVIF)" />
      </SectionCard>

      <SectionCard title="Coordonnées">
        <TextField label="Email" value={data.contact?.email} onChange={(v) => update('contact.email', v)} />
        <TextField label="Téléphone" value={data.contact?.phone} onChange={(v) => update('contact.phone', v)} />
        <TextAreaField label="Adresse" rows={2} value={data.contact?.address} onChange={(v) => update('contact.address', v)} />
        <TextField label="Horaires d'ouverture" value={data.contact?.hours} onChange={(v) => update('contact.hours', v)} />
      </SectionCard>

      <SectionCard title="Réseaux sociaux">
        <TextField label="Facebook (URL)" value={data.socials?.facebook} onChange={(v) => update('socials.facebook', v)} />
        <TextField label="Instagram (URL)" value={data.socials?.instagram} onChange={(v) => update('socials.instagram', v)} />
        <TextField label="LinkedIn (URL)" value={data.socials?.linkedin} onChange={(v) => update('socials.linkedin', v)} />
      </SectionCard>

      <SectionCard title="Plateforme de dons externe">
        <TextField label="URL HelloAsso (ou autre)" value={data.donateExternalUrl} onChange={(v) => update('donateExternalUrl', v)} />
      </SectionCard>
    </div>
  );
}
